import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { getSpeakerDetails } from '../utils/services';
import TALKS from '../mocks/talks.json';
import SPEAKERS from '../mocks/speakers.json';

const { Consumer, Provider } = React.createContext();

const SpeakerDetailsProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [speakers, setSpeakers] = useState([]);
  const [talks, setTalks] = useState([]);

  const loadSpeakerDetails = async () => {
    setIsLoading(true);
    // const details = await getSpeakerDetails(speakerId);
    setSpeakers(SPEAKERS);
    setTalks(TALKS);
    setIsLoading(false);
  };

  return (
    <Provider
      value={{
        isLoading,
        speakers,
        talks,
        loadSpeakerDetails
      }}>
      {children}
    </Provider>
  );
};

SpeakerDetailsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { SpeakerDetailsProvider, Consumer as SpeakerDetailsConsumer };
